import {
  DotMarkingContainer,
  dotMarkingGroupFor,
  requiresHazardLabel,
  requiresLargeIdNumber,
} from "./dotMarkingGroup";
import { printsRegulatedHazardLabel } from "./hazardClassDiamond";

/** The label fields that decide which extra pages a FULL label prints. */
export interface ExtraPageContent {
  dotIdNumber?: string | null;
  dotHazardClass?: string | null;
  dotSubsidiaryHazardClass?: string | null;
}

/**
 * The hazard classes that get a full-size label page, primary first and the
 * subsidiary after it (49 CFR 172.402(b)). Empty for a bulk container or
 * portable tank, and for a class that prints no regulated label.
 *
 * The PDF's page list and `pngExportLoss` both read this, so a PNG guard
 * cannot disagree with what the PDF renders.
 */
export function hazardLabelPageClasses(
  container: DotMarkingContainer,
  content: ExtraPageContent
): string[] {
  const group = dotMarkingGroupFor(container);
  if (!group || !requiresHazardLabel(group)) {
    return [];
  }
  const classes: string[] = [];
  for (const hazardClass of [content.dotHazardClass, content.dotSubsidiaryHazardClass]) {
    if (hazardClass && printsRegulatedHazardLabel(hazardClass)) {
      classes.push(hazardClass);
    }
  }
  return classes;
}

/**
 * What a FULL-layout PNG export would drop, or undefined when the label is
 * one page. A PNG rasterizes page 1 only. A bulk container or portable tank
 * with an ID number prints the 100mm ID number marking on page 2, and a
 * package with a class that has a symbol prints full-size hazard-class label
 * page(s).
 */
export function pngExportLoss(
  container: DotMarkingContainer,
  content: ExtraPageContent
): string | undefined {
  const group = dotMarkingGroupFor(container);
  if (group !== undefined && requiresLargeIdNumber(group) && content.dotIdNumber) {
    return "100mm ID number marking";
  }
  if (hazardLabelPageClasses(container, content).length > 0) {
    return "full-size hazard-class label(s)";
  }
  return undefined;
}
